
import Clarity from '@microsoft/clarity';
import { useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CLARITY_PROJECT_ID } from '../../../project_config';
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import Footer from "../../common/footer/Footer";
import { FooterButton } from "../../common/footer/FooterButton";
import Header from "../../common/header/Header";
import DoctorSection from "./doctor/DoctorSection";
import ExpertiseSection from "./expertise/ExpertiseSection";
import SearchSection from "./search/SearchSection";

export default function DoctorList() {
	Clarity.init(CLARITY_PROJECT_ID);
	const navigate = useNavigate();
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: 'درمانگران', href: `/doctor_list/` },
	];
	const [searchParams, setSearchParams] = useSearchParams();
	const expertiseIdParam = searchParams.get("expertise_id");
	const queryParam = searchParams.get("query");
	const doctorListFilterKey = `${(queryParam ?? "").trim()}|${(expertiseIdParam ?? "").trim()}`;

	function buildDoctorListUrl({ expertiseId = expertiseIdParam, query = queryParam } = {}) {
		const params = new URLSearchParams();
		const exp = expertiseId != null ? String(expertiseId).trim() : "";
		const q = query != null ? String(query).trim() : "";
		if (exp) params.set("expertise_id", exp);
		if (q) params.set("query", q);
		const qs = params.toString();
		return qs ? `/doctor_list/?${qs}` : "/doctor_list/";
	}

	function onExpertiseClick(newExpertiseId) {
		const nextId =
			String(newExpertiseId) !== String(expertiseIdParam ?? "")
				? newExpertiseId
				: "";
		navigate(buildDoctorListUrl({ expertiseId: nextId }));
	}

	function onSearch(newQuery) {
		const trimmed = (newQuery ?? "").trim();
		if (trimmed === (queryParam ?? "").trim()) {
			return;
		}
		navigate(buildDoctorListUrl({ query: trimmed }));
	}

	return (
		<>
			<Helmet>
				<title>درمانگران | همراهتیم</title>
				<meta name="description" content="فهرست درمانگران همراهتیم" />
			</Helmet>

			<div className="flex min-h-screen flex-col bg-[#F0F6FC]">
				<div className="flex flex-1 flex-col">
					<Header isDesktop={isDesktop} />
					<div className="bg-white">
						<div className={`${isDesktop ? "w-[1200px]" : ""} mx-auto`}>
							<Breadcrumb linkDataList={linkDataList} />
						</div>
					</div>
					<div
						className={`${isDesktop ? "w-[1200px]" : "px-[10px]"} mx-auto flex w-full max-w-full flex-col gap-5 pt-6 md:pt-8 pb-8`}
					>
						<SearchSection initQuery={queryParam} onSearch={onSearch} />
						<ExpertiseSection
							isDesktop={isDesktop}
							selectedExpertiseId={expertiseIdParam}
							onExpertiseClick={onExpertiseClick}
						/>
						<DoctorSection
							key={doctorListFilterKey}
							isDesktop={isDesktop}
							query={queryParam}
							expertiseId={expertiseIdParam}
						/>
					</div>
				</div>
				<Footer isDesktop={isDesktop} activeButton={FooterButton.WORKSHOPS} />
			</div>
		</>
	)
}
